import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import style from '../../style'

import Container from '../../partials/Container'
import GroupForm from '../../partials/GroupForm'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Community', 'Auth', 'User', 'Config')
@observer
export class CommunityGroupCreate extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      editor: {
        name: '',
        permissions: {
          community_support: false,
          community_stats: false,
          community_view: false,
          community_settings: false,
          community_user: false,
          community_transactions: false,
          community_group: false
        }
      }
    }
  }

  onPermClick (e) {
    const name = e.currentTarget.dataset.name
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        permissions: {
          ...this.state.editor.permissions,
          [name]: !this.state.editor.permissions[name]
        }
      }
    })
  }

  onNameInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        name: e.target.value
      }
    })
  }

  onNameInputBlur (e) {}

  onSaveClick (e) {
    e.preventDefault()
    const comId = this.props.match.params.comId

    this.props.Community.postCommunityGroup(comId, {
      ...this.state.editor,
      permissions: {
        ...Object.keys(this.state.editor.permissions).reduce(
          (obj, p) => ({
            ...obj,
            ...(this.state.editor.permissions[p] ? { [p]: true } : {})
          }),
          {}
        )
      }
    }).then(() => this.goBack())
  }

  goBack (e) {
    return this.props.history.push(this.props.match.url.replace(`/new`, ''))
  }

  render () {
    return (
      <Container {...this.props}>
        <Row>
          <Col>
            <Row>
              <Col xs='12' lg='6'>
                <h2 className={css(style.headers.h2)}>Create Group</h2>
              </Col>
              <Col>
                <Row>
                  <Col />
                  <Col>
                    <span
                      onClick={this.onSaveClick.bind(this)}
                      className={css(style.buttons.button, style.buttons.red)}
                    >
                      Save
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <GroupForm
              theme={THEME_LIST[this.props.Config.theme]}
              editor={this.state.editor}
              onPermClick={this.onPermClick.bind(this)}
              onNameInputBlur={this.onNameInputBlur.bind(this)}
              onNameInputChange={this.onNameInputChange.bind(this)}
            />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default CommunityGroupCreate



// WEBPACK FOOTER //
// ./src/components/Community/Group/Create/index.js